
import { Component, Vue } from 'vue-property-decorator'
import StepperTemp from '@/components/StepperTemp/index.vue'
@Component({
  components: {
    StepperTemp
  }
})
export default class packageSelector extends Vue {
  show = false
  goodsPrice = '12.54'

  closeRules() {
    this.show = false
  }
}
